import { type Layer, type NormalLayerSpec, defineNormalLayer } from '../../../core/layer';
import DEFINE from '../../../util/DEFINE';
import styles from '../__styles.module.scss';

const visInfo: Layer['visInfo'] = {
  id: 'summaryText',
  name_en: 'Summary Text',
  // name_zh: '概要文本',
  types_en: [],
  purpose_en: [],
  purpose_zh: [],
  standers: '',
  rules: {
    data: amount => amount === 1
  },
  /** 保证和 Spec.encoding 字段一致 */
  parameters: {
    x: { itemType: [DEFINE.STR, DEFINE.NUMBER], category: DEFINE.SINGLE }
  }
};

export interface Spec extends NormalLayerSpec {
  /** 使用的数据集索引，默认为 0 */
  dataIndex?: number;
  encoding: {
    x: string;
  };
}

export const layer = defineNormalLayer<Spec>({
  type: visInfo.id,
  visInfo,
  render(api, spec, $dom) {
    const { data: dataArray, hook } = api;
    const {
      dataIndex = 0,
      encoding: { x }
    } = spec;
    const data = dataArray[dataIndex].values;
    const dataMetaInfo = hook.parseDataMetaInfo(data);
    const presetOption = hook.buildStandardChartPresetOption(api);

    // * -------------------------- data
    const text = data[0][x] as string;
    const isNumberText = !Number.isNaN(+text);

    // * -------------------------- dom
    if (!isNumberText) {
      const fontFamily = presetOption.textStyle.fontFamily as string;
      const $textWrapper = document.createElement('div');

      $textWrapper.style.cssText = `font-family: ${fontFamily}; font-size: 14px; line-height: 20px; color: #1D2129;`;
      $textWrapper.textContent = text;

      $dom.classList.add(styles['hover-scrollbar']);
      $dom.appendChild($textWrapper);
    } else {
      const chartViewRect = $dom.getBoundingClientRect();
      const valueBaseFontSize = 40;
      const unitBaseFontSize = 24;
      const valueFontSize = Math.max(chartViewRect.width / 240, 1) * valueBaseFontSize;
      const unitFontSize = Math.max(chartViewRect.width / 240, 1) * unitBaseFontSize;
      const $textWrapper = document.createElement('div');
      const result = hook.formatDataNumberValue(text as unknown as number, {
        type: 'table',
        unit: dataMetaInfo[x]?.unit
      });
      // 字号基准
      const fontFamily = 'THSJinRongTi-Regular';

      $textWrapper.innerHTML = `
            <span style="font-size: ${valueFontSize}px; line-height: ${valueFontSize}px; margin-right: 12px;">${
              result.value
            }</span>
            <span style="font-size: ${valueFontSize}px; line-height: ${valueFontSize}px; transform-origin: left bottom; transform: scale(${
              unitFontSize / valueFontSize
            }) translateY(-${valueFontSize * 0.185}px)">${result.unit}</span>
          `;

      $textWrapper.style.cssText = `display: flex; flex-direction: row; align-items: flex-end; flex-wrap: nowrap; font-family: ${fontFamily}; padding-left: ${
        valueFontSize * (1 - 0.185) * String(result.unit || '').length
      }px;`;

      $dom.style.cssText +=
        'display: flex; flex-direction: column; align-items: center; justify-content: center; overflow: hidden;';

      $dom.appendChild($textWrapper);
    }

    return () => {
      // eslint-disable-next-line no-param-reassign
      $dom.innerHTML = '';
    };
  }
});
